import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CoupanServices from '../../services/CoupanServices';

function AddCoupanNew() {
    const navigate = useNavigate();

    const [formValues, setFormValues] = useState({
        name: '',
        description: '',
        upto: '',
        numberOfCoupons: '',
        endDate: '',
        price: '',
        discountType: '',
        maxDiscountAmount: '',
        termsAndConditions: '',
        totalnumberOfusagesCoupons: '',
        totalnumberOfusagesperuserCoupons: '',

    });

    // Handle form input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };
    const validateForm = () => {
        const { endDate } = formValues;
        const currentDate = new Date(); // Get the current date
        const selectedEndDate = new Date(endDate);

        // Ensure the end date is not earlier than the current date
        if (selectedEndDate < currentDate.setHours(0, 0, 0, 0)) {
            alert('End Date cannot be earlier than today.');
            return false;
        }

        return true;
    };
    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateForm()) return;
        try {
            const formData = new FormData();
            for (const key in formValues) {
                formData.append(key, formValues[key]);
            }

            await CoupanServices.createCoupan(formValues);
            alert('Coupan created successfully');
            navigate('/couponnew');
        } catch (error) {
            console.error('Failed to create Coupan', error);
            alert(error.response?.data?.message || 'Failed to create Coupan');

        }
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

                    <div className="my-auto">

                        <h5 className="page-title fs-21 mb-1">
                            New Generate Coupon Code
                        </h5>
                        <nav>

                            <ol className="breadcrumb mb-0">

                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Generate Coupon Code
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <Link className="list-banner-btn" to="/couponnew">Coupan Code List</Link>

                    </div>
                </div>

                <div className="container-box">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Coupon Code Name<span className="red">*</span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formValues.name}
                                                onChange={handleInputChange}
                                                placeholder="Enter name"
                                                required
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Discount Value (%)</label>
                                            <input
                                                type="number"
                                                name="upto"
                                                className="form-control"
                                                value={formValues.upto}
                                                onChange={handleInputChange}
                                                placeholder="5%"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-3">
                                        <div className="input-field">
                                            <label>Minimum Services Amount <span className="red">*</span></label>
                                            <input
                                                type="number"
                                                name="price"
                                                className="form-control"
                                                value={formValues.price}
                                                onChange={handleInputChange}
                                                placeholder="₹ 1500"
                                                required
                                                min="0"
                                                step="0"
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>MAX Discount Amount</label>
                                            <input
                                                type="number"
                                                name="maxDiscountAmount"
                                                className="form-control"
                                                required
                                                value={formValues.maxDiscountAmount}
                                                onChange={handleInputChange}
                                                placeholder="300"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Expire Date<span className="red">*</span></label>
                                            <input
                                                type="date"
                                                name="endDate"
                                                className="form-control"
                                                value={formValues.endDate}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of Usage Limit </label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesCoupons"
                                                className="form-control"
                                                required
                                                value={formValues.totalnumberOfusagesCoupons}
                                                onChange={handleInputChange}
                                                placeholder="10"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of usage per user</label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesperuserCoupons"
                                                className="form-control"
                                                required
                                                value={formValues.totalnumberOfusagesperuserCoupons}
                                                onChange={handleInputChange}
                                                placeholder="2"
                                            />
                                        </div>
                                    </div>

                                    {/* <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Applicable Services </label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesperuserCoupons"
                                                className="form-control"
                                                value={formValues.totalnumberOfusagesperuserCoupons}
                                                onChange={handleInputChange}
                                                placeholder="e.g., oil change, tire rotation"
                                            />
                                        </div>
                                    </div> */}




                                    {/* <div className="col-sm-12">
                                        <div className="input-field">
                                            <label>Description<span className="red">*</span></label>
                                            <textarea
                                                className="form-control video-desc"
                                                name="description"
                                                value={formValues.description}
                                                onChange={handleInputChange}
                                                placeholder="Enter description"
                                                required
                                            />
                                        </div>
                                    </div> */}


                                    {/* <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Up to Discount (%)</label>
                                            <input
                                                type="number"
                                                name="upto"
                                                className="form-control"
                                                value={formValues.upto}
                                                onChange={handleInputChange}
                                                placeholder="50"
                                            />
                                        </div>
                                    </div> */}

                                    {/* <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>MAX Discount Amount</label>
                                            <input
                                                type="number"
                                                name="maxDiscountAmount"
                                                className="form-control"
                                                value={formValues.maxDiscountAmount}
                                                onChange={handleInputChange}
                                                placeholder="500"
                                            />
                                        </div>
                                    </div> */}


                                    {/* <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of usages</label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesCoupons"
                                                className="form-control"
                                                value={formValues.totalnumberOfusagesCoupons}
                                                onChange={handleInputChange}
                                                placeholder="10"
                                            />
                                        </div>
                                    </div> */}


                                    {/* <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of usage per user</label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesperuserCoupons"
                                                className="form-control"
                                                value={formValues.totalnumberOfusagesperuserCoupons}
                                                onChange={handleInputChange}
                                                placeholder="2"
                                            />
                                        </div>
                                    </div> */}


                                    {/* <div className="col-lg-3 col-sm-6">
                                        <div className="input-field">
                                            <label>Number Of Coupons<span className="red">*</span></label>
                                            <input
                                                type="text"
                                                name="numberOfCoupons"
                                                className="form-control"
                                                value={formValues.numberOfCoupons}
                                                onChange={handleInputChange}
                                                placeholder="50"
                                                required
                                            />
                                        </div>
                                    </div> */}


                                    {/* <div className="col-lg-3 col-sm-3">
                                        <div className="input-field">
                                            <label>Amount<span className="red">*</span></label>
                                            <input
                                                type="number"
                                                name="price"
                                                className="form-control"
                                                value={formValues.price}
                                                onChange={handleInputChange}
                                                placeholder="₹ 200"
                                                required
                                                min="0"
                                                step="0"
                                            />
                                        </div>
                                    </div> */}

                                    {/* <div className="col-md-3">
                                        <div className="input-field">
                                            <label>Expire Date<span className="red">*</span></label>
                                            <input
                                                type="date"
                                                name="endDate"
                                                className="form-control"
                                                value={formValues.endDate}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div> */}


                                    {/* <div className="col-md-3 d-flex align-items-center">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="discountType"
                                                value="Percentage"
                                                checked={formValues.discountType === 'Percentage'}
                                                onChange={handleInputChange}
                                            />
                                            <label className="form-check-label add-vechile-check-btn">
                                                Percentage
                                            </label>
                                        </div>
                                    </div> */}

                                    <div className="col-lg-12 col-sm-12">
                                        <div className="input-field">
                                            <label>Terms And Conditions</label>
                                            <textarea
                                                className="form-control video-desc h-auto"
                                                name="termsAndConditions"
                                                value={formValues.termsAndConditions}
                                                onChange={handleInputChange}
                                                placeholder="Enter Terms And Conditions"
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* <div className="col-md-2 d-flex align-items-center">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="discountType"
                                                value="Rupees"
                                                checked={formValues.discountType === 'Rupees'}
                                                onChange={handleInputChange}
                                            />
                                            <label className="form-check-label add-vechile-check-btn">
                                                Rupees
                                            </label>
                                        </div>
                                    </div> */}
                                </div>
                                <button className="submit-green-btn">SUBMIT</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddCoupanNew;
